import { render, staticRenderFns } from "./buy_new.vue?vue&type=template&id=1a8db9b2&scoped=true&"
import script from "./buy_new.vue?vue&type=script&lang=js&"
export * from "./buy_new.vue?vue&type=script&lang=js&"
import style0 from "./buy_new.vue?vue&type=style&index=0&id=1a8db9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8db9b2",
  null
  
)

export default component.exports